import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const customMaskValidator = (customMask: RegExp, example: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value && !customMask.test(value)) {
      return { customFormat: { customMask, example } };
    }
    return null;
  };
};
